import type { CheckoutConfig } from '#types/config/components/checkout'

export default {
  presets: {
    size: {
      width: 120,
      height: 120
    }
  }
} satisfies CheckoutConfig['orderItem']
